// extracted by mini-css-extract-plugin
module.exports = {"question":"style_question__2XKmG"};